// app.js

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import List from '@ckeditor/ckeditor5-list/src/list';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import Link from '@ckeditor/ckeditor5-link/src/link';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';

import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageInline from '@ckeditor/ckeditor5-image/src/imageinline';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import ImageConfig from '@ckeditor/ckeditor5-image/src/image';
import ImageResizeEditing from '@ckeditor/ckeditor5-image/src/imageresize/imageresizeediting';
import ImageResizeHandles from '@ckeditor/ckeditor5-image/src/imageresize/imageresizehandles';

import { MediaEmbed } from '@ckeditor/ckeditor5-media-embed';
import GeneralHtmlSupport from '@ckeditor/ckeditor5-html-support/src/generalhtmlsupport';

import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';

import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';

import SimpleBox from './simplebox/simplebox';
import SimpleBox2 from './simplebox2/simplebox2';

var allEditors = document.querySelectorAll('.ckEditor');

const config = {
    plugins: [
        CKFinder,
        SourceEditing,
        Essentials,
        UploadAdapter,
        Bold,
        Italic,
        Heading,
        Image, ImageInline, ImageCaption, ImageStyle, ImageToolbar, ImageUpload, ImageConfig, ImageResize, ImageResizeEditing, ImageResizeHandles,
        Link,
        List,
        Paragraph,
        Alignment,
        Table, TableToolbar,
        SimpleBox,
        SimpleBox2,
        GeneralHtmlSupport,
        MediaEmbed,
    ],
    toolbar: {
        items: [
            'sourceEditing',
            'ckfinder',
            'heading',
            '|',
            'alignment',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'uploadImage',
            'mediaEmbed',
            'insertTable',
            '|',
            'undo',
            'redo',
            'simpleBox',
            'simpleBox2',
        ]
    },
    image: {
        toolbar: [
            'imageTextAlternative',
            'toggleImageCaption',
            'imageStyle:inline',
            '|',
            'imageStyle:alignLeft',
            // 'imageStyle:full', 
            'imageStyle:alignRight',
            '|',
            {
                name: 'imageStyle:pictures',
                items: ['imageStyle:block', 'imageStyle:side'],
                defaultItem: 'imageStyle:block'
            }],
        styles: [
            'full',
            'alignLeft',
            'alignRight'
        ],
        resizeOptions: [
            {
                name: 'resizeImage:original',
                value: null,
                label: 'Original'
            },
            {
                name: 'resizeImage:25',
                value: '25',
                label: '25%'
            },
            {
                name: 'resizeImage:50',
                value: '50',
                label: '50%'
            },
            {
                name: 'resizeImage:100',
                value: '100',
                label: '100%'
            }
        ],
    },
    mediaEmbed: {
        previewsInData: true
    },
    htmlSupport: {
        allow: [
            {
                name: /.*/,
                attributes: true,
                classes: true,
                styles: true
            }
        ],
        disallow: [ /* HTML features to disallow */]
    },
    language: 'nl',
}

for (const key in allEditors) {
    if (Object.hasOwnProperty.call(allEditors, key)) {
        const editor = allEditors[key];

        ClassicEditor
            .create(editor, config)
            .then(editor => {
                // // To see all enabled toolbaritems
                // console.log(Array.from(editor.ui.componentFactory.names()));

                // Expose for playing in the console.
                window.editor = editor;
            })
            .catch(error => {
                console.log('error');
                console.error(error.stack);
            });

    }
}